import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, type InputProps } from '@/components/ui/input';
import { Icon } from './Icon';
import { cn } from '@/lib/utils';

type PasswordInputProps = Omit<InputProps, 'type'>;

// Password input with the inline eye-toggle from the mobile login design.
export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, ...props }, ref) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    return (
      <div className="relative">
        <Input
          {...props}
          ref={ref}
          type={show ? 'text' : 'password'}
          className={cn('pr-11', className)}
        />
        <button
          type="button"
          onClick={() => setShow((v) => !v)}
          aria-label={show ? t('auth.hidePassword') : t('auth.showPassword')}
          tabIndex={-1}
          className="absolute right-1 top-1 inline-flex h-10 w-10 items-center justify-center rounded-md text-muted hover:text-ink"
        >
          <Icon name={show ? 'eye_off' : 'eye'} size={18} />
        </button>
      </div>
    );
  },
);
PasswordInput.displayName = 'PasswordInput';
